module.exports = __webpack_public_path__ + "img/ilustrasi-sign-up.7e786a0c.svg";